import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

export default function PlantasComponent({ imagen, imagenDesk = "/", nombre, width, height, info, metros, incluye, footerFlex = false, fondoColor = " #FFFFFF", destacada = false, reverse = false, ultimaUnidad = false }) {
    return (
        <div className={`planta-component ${destacada ? 'destacada' : ''} ${reverse ? 'reversa' : ''} ${ultimaUnidad ? 'ultima-unidad' : ''}`}>
            <div className="imagen" >
                <div className="tablet">
                    <img
                        src={imagen}
                        alt={nombre}
                    />
                </div>

                <div className="note" style={{ textAlign: "center" }}>
                    <img
                        src={imagenDesk}
                        alt={nombre}
                        style={{ objectFit: "contain", width: "80%" }}
                    />
                </div>
            </div>
            <div className="contenido" style={{ backgroundColor: fondoColor }}>
                <p className="nombre-planta">{nombre}</p>

                {info.map((item, key) => {
                    return (<p key={key} className="info-planta">{item}</p>)
                })}

                <p className="metros">{metros} m<sup>2</sup></p>

                <div className="incluye">
                    <p className="titulo-incluye">Incluye</p>

                </div>
                <div className={`footer-component ${footerFlex ? 'footer-flex' : ''}`}>
                    <div className="datos-incluye">
                        {incluye.map((item, key) => {
                            return (<p key={key} className="incluye-planta">{item}</p>)
                        })}
                    </div>

                    <div className="boton-cotiza">
                        <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                            Cotiza
                        </Button>
                    </div>
                </div>
            </div>
        </div >
    )
}

